// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-disabled[data-v-1bd3d027]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
